import { _ as _slicedToArray } from '../slicedToArray-45a33045.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { useState, useEffect } from 'react';
import '../unsupportedIterableToArray-5baf4325.js';
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref = process.env.NODE_ENV === "production" ? {
  name: "vovflj",
  styles: "*:focus{outline:0;}*::-moz-focus-inner{border:0;}"
} : {
  name: "nm808k-css",
  styles: "*:focus{outline:0;}*::-moz-focus-inner{border:0;};label:css;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRhYk91dGxpbmVDb250cm9sbGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFzQm1CIiwiZmlsZSI6IlRhYk91dGxpbmVDb250cm9sbGVyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XHJcbmltcG9ydCB7IHVzZUVmZmVjdCwgdXNlU3RhdGUsIH0gZnJvbSAncmVhY3QnO1xyXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XHJcbmV4cG9ydCBjb25zdCBUYWJPdXRsaW5lQ29udHJvbGxlciA9ICh7IGNoaWxkcmVuIH0pID0+IHtcclxuICAgIGNvbnN0IFtvdXRsaW5lQWN0aXZlLCBzZXRPdXRsaW5lQWN0aXZlXSA9IHVzZVN0YXRlKHRydWUpO1xyXG4gICAgdXNlRWZmZWN0KCgpID0+IHtcclxuICAgICAgICBjb25zdCBvbktleURvd24gPSAoeyBrZXkgfSkgPT4ge1xyXG4gICAgICAgICAgICBpZiAoa2V5ID09PSAnVGFiJykge1xyXG4gICAgICAgICAgICAgICAgc2V0T3V0bGluZUFjdGl2ZSh0cnVlKTtcclxuICAgICAgICAgICAgfVxyXG4gICAgICAgIH07XHJcbiAgICAgICAgY29uc3Qgb25Nb3VzZURvd24gPSAoKSA9PiB7XHJcbiAgICAgICAgICAgIHNldE91dGxpbmVBY3RpdmUoZmFsc2UpO1xyXG4gICAgICAgIH07XHJcbiAgICAgICAgZG9jdW1lbnQuYWRkRXZlbnRMaXN0ZW5lcigna2V5ZG93bicsIG9uS2V5RG93biwgdHJ1ZSk7XHJcbiAgICAgICAgZG9jdW1lbnQuYWRkRXZlbnRMaXN0ZW5lcignbW91c2Vkb3duJywgb25Nb3VzZURvd24sIHRydWUpO1xyXG4gICAgICAgIHJldHVybiAoKSA9PiB7XHJcbiAgICAgICAgICAgIGRvY3VtZW50LnJlbW92ZUV2ZW50TGlzdGVuZXIoJ2tleWRvd24nLCBvbktleURvd24sIHRydWUpO1xyXG4gICAgICAgICAgICBkb2N1bWVudC5yZW1vdmVFdmVudExpc3RlbmVyKCdtb3VzZWRvd24nLCBvbk1vdXNlRG93biwgdHJ1ZSk7XHJcbiAgICAgICAgfTtcclxuICAgIH0sIFtdKTtcclxuICAgIHJldHVybiAoX2pzeChcInNwYW5cIiwgeyBjc3M6ICFvdXRsaW5lQWN0aXZlXHJcbiAgICAgICAgICAgICYmIGNzcyBgXHJcbiAgICAgICAgICAgICo6Zm9jdXMge1xyXG4gICAgICAgICAgICAgIG91dGxpbmU6IDA7XHJcbiAgICAgICAgICAgIH1cclxuICAgICAgICAgICAgKjo6LW1vei1mb2N1cy1pbm5lciB7XHJcbiAgICAgICAgICAgICAgYm9yZGVyOiAwO1xyXG4gICAgICAgICAgICB9XHJcbiAgICAgICAgICBgLCBjaGlsZHJlbjogY2hpbGRyZW4gfSkpO1xyXG59O1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1UYWJPdXRsaW5lQ29udHJvbGxlci5qcy5tYXAiXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var TabOutlineController = function TabOutlineController(_ref2) {
  var children = _ref2.children;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    outlineActive = _useState2[0],
    setOutlineActive = _useState2[1];
  useEffect(function () {
    var onKeyDown = function onKeyDown(_ref3) {
      var key = _ref3.key;
      if (key === 'Tab') {
        setOutlineActive(true);
      }
    };
    var onMouseDown = function onMouseDown() {
      setOutlineActive(false);
    };
    document.addEventListener('keydown', onKeyDown, true);
    document.addEventListener('mousedown', onMouseDown, true);
    return function () {
      document.removeEventListener('keydown', onKeyDown, true);
      document.removeEventListener('mousedown', onMouseDown, true);
    };
  }, []);
  return jsx("span", {
    css: !outlineActive && _ref,
    children: children
  });
};
export { TabOutlineController };